import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AttendanceRoutes = defineRoute({
    record: {
        route: {
            path: "/attendance",
            component: () => loadView(import("./AttendanceHome.vue")),
        },
    },
});
